import { EditorState } from 'draft-js';

import Icon from 'components/shared/Icon';
import RedoIcon from 'components/shared/Icon/icons/Redo';
import UndoIcon from 'components/shared/Icon/icons/Undo';
import { useWysiwygContext } from 'components/shared/Wysiwyg/Wysiwyg.contex';

import { BaseItemButton } from '../Base';

type Props = {
  type: 'undo' | 'redo';
};

const UndoRedo = (props: Props) => {
  const { editor } = useWysiwygContext();
  const icon = props.type === 'undo' ? UndoIcon : RedoIcon;

  const onClick = () => {
    editor.handleChange(EditorState[props.type](editor.editorState));
  };

  return (
    <BaseItemButton onClick={onClick}>
      <Icon width="18" height="18" component={icon} />
    </BaseItemButton>
  );
};

export const Undo = () => <UndoRedo type="undo" />;
export const Redo = () => <UndoRedo type="redo" />;
